import { IFiltroListarContatos } from "../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import {
    DesvincularContatosService,
    ListarContatosFiltroService,
    VincularContatosService,
} from "../../../Services/Automacao/Contato/ContatoServices";
import { Controller } from "../../Controller";

export async function ListarContatosFiltroController(
    requestBody: IFiltroListarContatos
) {
    return Controller(ListarContatosFiltroService(requestBody));
}

export async function VincularContatosController(
    idAudiencia: number,
    idContatos: Array<number>
) {
    return Controller(VincularContatosService(idAudiencia, idContatos));
}

export async function DesvincularContatosController(
    idAudiencia: number,
    idContatos: Array<number>
) {
    return Controller(DesvincularContatosService(idAudiencia, idContatos));
}
